import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('Receptions', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  receptions: [],
  isModalDetailsReceptionVisible: false
}

const mutations = {
  ...crud.mutations,
  SET_MODAL_DETAILS_RECEPTION_VISIBLE (state, payload) {
    state.isModalDetailsReceptionVisible = payload
  }
}

const actions = {
  ...crud.actions,
  setModalDetailsReceptionVisible ({ commit }, payload) {
    commit('SET_MODAL_DETAILS_RECEPTION_VISIBLE', payload)
  }
}

const getters = {
  ...crud.getters,
  receptions: state => state.receptions,
  isModalDetailsReceptionVisible: state => state.isModalDetailsReceptionVisible
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
